import { useTranslation } from "react-i18next";

import { simplyClick } from "shared/helpers/analytics";
import { onSignOutActions } from "shared/helpers/auth";

import styles from "@platformAssets/components/Wizard.module.scss";

import { ReactComponent as SignoutIcon } from "assets/shared/img/icons/signout.svg";
import { ReactComponent as TrashIcon } from "assets/shared/img/icons/trash.svg";

type WizardUserMenuDropDownProps = {
  onClose: () => void;
  onDeleteAccount: () => void;
};

const WizardUserMenuDropDown = ({
  onClose,
  onDeleteAccount,
}: WizardUserMenuDropDownProps) => {
  const { t } = useTranslation("wizardNew");

  const handleClickSignOut = () => {
    simplyClick(window.simplyEvent.cl_av_sign_out);
    onClose();

    onSignOutActions();
  };

  const handleClickDelete = () => {
    simplyClick(window.simplyEvent.cl_av_sign_out_delete_profile);
    onDeleteAccount();
  };

  return (
    <div className={styles.wizardMenuDropdown}>
      <a
        href="/app/logout?backUrl=/login/"
        className={styles.wizardMenuItem}
        onClick={handleClickSignOut}
      >
        <SignoutIcon />
        <span>{t("menu.signOut")}</span>
      </a>

      <button
        type="button"
        className={styles.wizardMenuItem}
        onClick={handleClickDelete}
      >
        <TrashIcon />
        <span>{t("menu.signOutAndDelete")}</span>
      </button>
    </div>
  );
};

export default WizardUserMenuDropDown;
